import {call, put, takeLatest} from 'redux-saga/effects';
import eulaActions from '../actions/eula.actions';
import EulaApi from '../api/EulaApi';
import {getLocale} from 'epic-common/src/locale';
import errorActions from '../actions/error.actions';

function* fetchAffiliateAgreement() {
    try {
        const params = {
            locale: getLocale()
        };
        const response = yield call(EulaApi.getAffiliateAgreement, params);
        yield put(eulaActions.getAffiliateAgreementSuccess(response));
    } catch (e) {
        console.error('error fetching affiliate agreement', e.message);
        if (e.response && e.response.data) {
            yield put(errorActions.showErrorMessage(e.response.data));
        }
        yield put(eulaActions.getAffiliateAgreementFailed(e));
    }
}

function* fetchConductAgreement() {
    try {
        const params = {
            locale: getLocale()
        };
        const response = yield call(EulaApi.getCodeOfConduct, params);
        yield put(eulaActions.getConductAgreementSuccess(response));
    } catch (e) {
        console.error('error fetching code of conduct agreement', e.message);
        if (e.response && e.response.data) {
            yield put(errorActions.showErrorMessage(e.response.data));
        }
        yield put(eulaActions.getConductAgreementFailed(e));
    }
}

function* eulaSaga() {
    yield takeLatest(eulaActions.TYPES.GET_AFFILIATE_AGREEMENT, fetchAffiliateAgreement);
    yield takeLatest(eulaActions.TYPES.GET_CONDUCT_AGREEMENT, fetchConductAgreement);
}

export default eulaSaga;
